import {
  Box,
  Button,
  FormLabel,
  Input,
  Select,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { BsPlus } from "react-icons/bs";
import { getAllGeneres, getLanguage, uploadFile } from "../../utils/api";
import BunnyVideoSelector from "../common/BunnyVideoSelector";
import CreateModal from "../common/Modal/Modal";
import PreviewModal from "../common/Modal/PreviewModal";
import { videoAPI } from "../../utils/bunnyApi";
import CheckboxInput from "../common/TextInputs/Checkbox";
import CreateInput from "../common/TextInputs/Input";

const Modal = ({
  save,
  title,
  series,
  update,
  color,
  episeries,
  categories,
  buttonText,
}) => {
  const toast = useToast();
  const [newCast, setNewCast] = React.useState({
    name: "",
    image: "",
    role: "",
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isBunnyMainOpen,
    onOpen: onBunnyMainOpen,
    onClose: onBunnyMainClose,
  } = useDisclosure();
  const {
    isOpen: isBunnyTrailerOpen,
    onOpen: onBunnyTrailerOpen,
    onClose: onBunnyTrailerClose,
  } = useDisclosure();
  const [genre, setGenre] = React.useState([]);
  const [allGenre, setAllGenre] = React.useState([]);
  const [allLanguages, setAllLanguages] = React.useState([]);
  const [newPodcast, setNewPodcast] = React.useState({});
  const [cast, setCast] = React.useState([]);

  // Preview modal states
  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onClose: onPreviewClose,
  } = useDisclosure();
  const [previewUrl, setPreviewUrl] = React.useState("");
  const [previewTitle, setPreviewTitle] = React.useState("");
  const [previewUrlType, setPreviewUrlType] = React.useState("");

  // Function to handle preview
  const handlePreview = (url, title, urlType) => {
    setPreviewUrl(url);
    setPreviewTitle(title);
    setPreviewUrlType(urlType);
    onPreviewOpen();
  };

  // File upload handlers
  const handleHorizontalBannerUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const [success, link] = await uploadFile(file);
      if (success) {
        setNewPodcast((prev) => ({ ...prev, horizontalBanner: link }));
        toast({
          title: "Success",
          description: "Horizontal banner uploaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: "Failed to upload horizontal banner",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const handleVerticalBannerUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const [success, link] = await uploadFile(file);
      if (success) {
        setNewPodcast((prev) => ({ ...prev, verticalBanner: link }));
        toast({
          title: "Success",
          description: "Vertical banner uploaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: "Failed to upload vertical banner",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  // Cast image upload handler
  const handleCastImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const [success, link] = await uploadFile(file);
      if (success) {
        setNewCast((prev) => ({ ...prev, image: link }));
        toast({
          title: "Success",
          description: "Cast image uploaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: "Failed to upload cast image",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const podcastDataChage = (e, name) => {
    const { value } = e.target;
    setNewPodcast((prev) => ({ ...prev, [name]: value }));
  };

  const handleBunnyMainVideoSelect = (video) => {
    const playlistUrl = videoAPI.getPlaylistUrl(video.guid);
    const mp4UrlMap = videoAPI.getMp4UrlMap(video.guid);
    const mp4Url480p = videoAPI.getMp4Url(video.guid, "480p");
    const thumbnailUrl = videoAPI.getThumbnailUrl(video.guid);
    const hasExistingBanner = Boolean(
      (newPodcast.horizontalBanner ?? update?.horizontalBanner)?.trim(),
    );
    const usedBunnyThumbnail = update && !hasExistingBanner;
    setNewPodcast((prev) => ({
      ...prev,
      url: playlistUrl,
      videoId: video.guid,
      mp4UrlArray: JSON.stringify(mp4UrlMap),
      mp4Url: mp4Url480p,
      ...(usedBunnyThumbnail && { horizontalBanner: thumbnailUrl }),
    }));
    toast({
      title: "Video selected",
      description: usedBunnyThumbnail
        ? `"${video.title}" set as main content URL. Bunny thumbnail used as horizontal banner.`
        : `"${video.title}" set as main content URL`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleBunnyTrailerSelect = (video) => {
    setNewPodcast((prev) => ({
      ...prev,
      trailer: videoAPI.getPlaylistUrl(video.guid),
    }));
    toast({
      title: "Trailer selected",
      description: `"${video.title}" set as trailer`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const durationCovertion = (duration) => {
    let time = duration;
    let sp = time?.split(" ");
    let hr = 0;
    let min = 0;
    let sec = 0;

    for (let i = 0; i < sp?.length; i++) {
      if (sp[i]?.includes("hr")) {
        const textArray = sp[i]?.split("hr");
        hr = Number(textArray?.shift());
      } else if (sp[i]?.includes("min")) {
        const textArray = sp[i]?.split("min");
        min = Number(textArray?.shift());
      } else {
        const textArray = sp[i]?.split("sec");
        sec = Number(textArray?.shift());
      }
    }

    return {
      hr,
      min,
      sec,
    };
  };
  const getAllGeneresHandler = async () => {
    const [success, data] = await getAllGeneres();
    if (success) {
      setAllGenre(data);
    }
  };

  const getAllLanguagesHandler = async () => {
    const [success, data] = await getLanguage();
    if (success) {
      setAllLanguages(data);
    }
  };

  useEffect(() => {
    if (update) {
      setNewPodcast({
        name: update?.name,
        url: update?.url,
        urlType: update?.urlType,
        description: update?.description,
        verticalBanner: update?.verticalBanner,
        horizontalBanner: update?.horizontalBanner,
        duration: durationCovertion(update?.duration),
        language: update?.language?.name || update?.language || "",
        rating: update?.rating,
        ageLimit: update?.ageLimit,
        trailer: update?.trailer,
        trailerType: update?.trailerType,
        promotionalLink: update?.promotionalLink,
        extraCast: update?.extraCast,
        subcategory: update?.subcategory,
        view: update?.view,
      });
      setGenre(update?.genres);
      setCast(update?.cast);
    }
  }, [update]);
  const saveHandler = async () => {
    if (
      newPodcast?.name &&
      newPodcast?.description &&
      newPodcast?.verticalBanner &&
      newPodcast?.horizontalBanner &&
      (series || newPodcast?.duration) &&
      (series || episeries || newPodcast?.subcategory) &&
      (episeries || newPodcast?.language) &&
      (episeries || genre?.length > 0)
    ) {
      let duration = "";
      if (+newPodcast?.duration?.hr && +newPodcast?.duration?.hr !== 0) {
        duration = duration + newPodcast?.duration?.hr + "hr ";
      }
      if (+newPodcast?.duration?.min && +newPodcast?.duration?.min !== 0) {
        duration = duration + newPodcast?.duration?.min + "min ";
      }
      if (+newPodcast?.duration?.sec && +newPodcast?.duration?.sec !== 0) {
        duration = duration + newPodcast?.duration?.sec + "sec";
      }
      const newPodcastData = {
        ...newPodcast,
        duration: duration,
        view: newPodcast?.view,
        genres: genre,
        cast: cast,
        contentType:
          series ||
          update?.contentType === "Series" ||
          update?.type === "Multiple"
            ? "Series"
            : update?.contentType || "Movie",
        type:
          series ||
          update?.contentType === "Series" ||
          update?.type === "Multiple"
            ? "Multiple"
            : "Single",
        ...(Array.isArray(update?.episodes) && update.episodes.length > 0
          ? { episodes: update.episodes }
          : {}),
      };
      if (!update) {
        setNewPodcast((prev) => ({
          ...prev,
          name: "",
          description: "",
          verticalBanner: "",
          horizontalBanner: "",
          url: "",
          urlType: "",
          trailerType: "",
          subcategory: "",
          duration: {
            hr: 0,
            min: 0,
            sec: 0,
          },
          language: "",
          rating: "",
          ageLimit: "",
          trailer: "",
          promotionalLink: "",
          extraCast: "",
        }));
      }
      await save(newPodcastData, update?._id);
      onClose();
    } else {
      toast({
        title: "Error",
        description: "Please fill all the fields",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      sx={{
        gap: 3,
        width: "100%",
      }}
    >
      <Button
        onClick={() => {
          if (update?.paymentStatus !== "Unpaid") {
            getAllGeneresHandler();
            getAllLanguagesHandler();
            onOpen();
          } else {
            toast({
              title: "Error",
              description: "Payment Not Done",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          }
        }}
        sx={{
          width: "100%",
        }}
        leftIcon={!color && <BsPlus />}
        colorScheme={color ? color : "blue"}
      >
        {title}
      </Button>
      <CreateModal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        create={saveHandler}
        button1={buttonText}
      >
        <CreateInput
          name="Name"
          onChange={(e) => podcastDataChage(e, "name")}
          value={newPodcast?.name ? newPodcast.name : ""}
        />
        <CreateInput
          name="Description"
          onChange={(e) => {
            podcastDataChage(e, "description");
          }}
          value={newPodcast?.description ? newPodcast.description : ""}
        />
        {update?.episodes?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              padding: "0.75rem",
              backgroundColor: "#f7fafc",
              borderRadius: "0.5rem",
              border: "1px solid #e2e8f0",
            }}
          >
            <Text fontSize={"md"} fontWeight={"semibold"}>
              Episodes ({update?.episodes?.length || 0})
            </Text>
            {update?.episodes?.length > 0 ? (
              update.episodes.map((episode, index) => (
                <Box
                  key={episode._id || index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "0.5rem",
                    borderBottom: "1px solid #edf2f7",
                    paddingBottom: "0.35rem",
                  }}
                >
                  <Text fontSize="sm">
                    {episode.seasonNumber
                      ? `S${episode.seasonNumber}E${
                          episode.episodeNumber || index + 1
                        } · `
                      : `${index + 1}. `}
                    {episode.name || "Untitled episode"}
                    {episode.duration ? ` (${episode.duration})` : ""}
                  </Text>
                  {episode.url && (
                    <Button
                      size="xs"
                      colorScheme="blue"
                      variant="outline"
                      onClick={() =>
                        handlePreview(
                          episode.url,
                          episode.name || `Episode ${index + 1}`,
                          episode.urlType || "Video"
                        )
                      }
                    >
                      Preview
                    </Button>
                  )}
                </Box>
              ))
            ) : (
              <Text fontSize="sm" color="gray.500">
                No episodes found on this request.
              </Text>
            )}
          </Box>
        )}
        {!series && (
          <>
            <Text fontSize={"md"} fontWeight={"semibold"}>
              Url-Type
            </Text>
            <Select
              placeholder="Select Url-Type"
              value={newPodcast?.urlType ? newPodcast.urlType : ""}
              onChange={(e) => {
                setNewPodcast((prev) => ({
                  ...prev,
                  urlType: e.target.value,
                }));
              }}
            >
              <option value="Youtube">Youtube</option>
              <option value="Video">Video</option>
            </Select>
            {newPodcast?.urlType === "Video" ? (
              <Box display="flex" flexDirection="column" gap={2} mb={2}>
                <Text fontSize="sm" color="gray.600">
                  Pick a video from your Bunny library (HLS URL is filled
                  automatically).
                </Text>
                <Input
                  readOnly
                  placeholder="Select video from Bunny"
                  value={newPodcast?.url ? newPodcast.url : ""}
                />
                <Button colorScheme="blue" onClick={onBunnyMainOpen}>
                  Select main video (Bunny)
                </Button>
                {newPodcast?.url && (
                  <Button
                    colorScheme="blue"
                    variant="outline"
                    onClick={() =>
                      handlePreview(
                        newPodcast.url,
                        "Main Content Preview",
                        newPodcast.urlType
                      )
                    }
                  >
                    Preview
                  </Button>
                )}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  gap: "0.5rem",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <CreateInput
                  name="Url"
                  onChange={(e) => {
                    podcastDataChage(e, "url");
                  }}
                  value={newPodcast?.url ? newPodcast.url : ""}
                />
                {newPodcast?.url && (
                  <Button
                    colorScheme="blue"
                    onClick={() =>
                      handlePreview(
                        newPodcast.url,
                        "Main Content Preview",
                        newPodcast.urlType
                      )
                    }
                  >
                    Preview
                  </Button>
                )}
              </Box>
            )}
          </>
        )}

        {!episeries && !series && (
          <>
            {" "}
            <Text fontSize={"md"} fontWeight={"semibold"}>
              Sub Category
            </Text>
            <Select
              placeholder="Select Sub Category"
              value={newPodcast?.subcategory ? newPodcast.subcategory : ""}
              onChange={(e) => {
                setNewPodcast((prev) => ({
                  ...prev,
                  subcategory: e.target.value,
                }));
              }}
            >
              {categories?.map((item, index) => (
                <option key={index} value={item.title}>
                  {item.title}
                </option>
              ))}
            </Select>
          </>
        )}
        {!episeries && (
          <>
            <Text fontSize={"md"} fontWeight={"semibold"}>
              Trailer-Type
            </Text>
            <Select
              placeholder="Select Trailer-Type"
              value={newPodcast?.trailerType ? newPodcast.trailerType : ""}
              onChange={(e) => {
                setNewPodcast((prev) => ({
                  ...prev,
                  trailerType: e.target.value,
                }));
              }}
            >
              <option value="Youtube">Youtube</option>
              <option value="Video">Video</option>
            </Select>
          </>
        )}
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
            flexDirection: "row",
            alignItems: "end",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Text fontSize={"md"} fontWeight={"semibold"} mb={2}>
              Horizontal Banner
            </Text>
            <Input
              type="file"
              accept="image/*"
              onChange={handleHorizontalBannerUpload}
              sx={{
                border: "1px solid #e2e8f0",
                borderRadius: "0.375rem",
                padding: "0.5rem",
              }}
            />
            {newPodcast?.horizontalBanner && (
              <Text fontSize="sm" color="green.500" mt={1}>
                ✓ Uploaded
              </Text>
            )}
            {update && newPodcast?.horizontalBanner && (
              <Button
                colorScheme="blue"
                onClick={() =>
                  handlePreview(
                    newPodcast.horizontalBanner,
                    "Horizontal Banner Preview",
                    "image"
                  )
                }
              >
                Preview
              </Button>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
            flexDirection: "row",
            alignItems: "end",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Text fontSize={"md"} fontWeight={"semibold"} mb={2}>
              Vertical Banner
            </Text>
            <Input
              type="file"
              accept="image/*"
              onChange={handleVerticalBannerUpload}
              sx={{
                border: "1px solid #e2e8f0",
                borderRadius: "0.375rem",
                padding: "0.5rem",
              }}
            />
            {newPodcast?.verticalBanner && (
              <Text fontSize="sm" color="green.500" mt={1}>
                ✓ Uploaded
              </Text>
            )}
            {update && newPodcast?.verticalBanner && (
              <Button
                colorScheme="blue"
                onClick={() =>
                  handlePreview(
                    newPodcast.verticalBanner,
                    "Vertical Banner Preview",
                    "image"
                  )
                }
              >
                Preview
              </Button>
            )}
          </Box>
        </Box>
        {!series && (
          <Box sx={{ display: "flex", gap: "0.5rem", flexDirection: "column" }}>
            <Text fontSize={"md"} fontWeight={"semibold"}>
              Duration
            </Text>
            <Box sx={{ display: "flex", gap: "0.7rem" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: "0.5rem",
                  alignItems: "center",
                }}
              >
                <Select
                  value={newPodcast?.duration?.hr}
                  onChange={(e) => {
                    setNewPodcast((prev) => ({
                      ...prev,
                      duration: {
                        ...prev.duration,
                        hr: e.target.value,
                      },
                    }));
                  }}
                >
                  {Array.from(Array(25).keys()).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Select>
                <Text fontSize={"md"}>hr</Text>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: "0.5rem",
                  alignItems: "center",
                }}
              >
                <Select
                  value={newPodcast?.duration?.min}
                  onChange={(e) => {
                    setNewPodcast((prev) => ({
                      ...prev,
                      duration: {
                        ...prev.duration,
                        min: e.target.value,
                      },
                    }));
                  }}
                >
                  {Array.from(Array(61).keys()).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Select>
                <Text fontSize={"md"}>min</Text>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: "0.5rem",
                  alignItems: "center",
                }}
              >
                <Select
                  value={newPodcast?.duration?.sec}
                  onChange={(e) => {
                    setNewPodcast((prev) => ({
                      ...prev,
                      duration: {
                        ...prev.duration,
                        sec: e.target.value,
                      },
                    }));
                  }}
                >
                  {Array.from(Array(61).keys()).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Select>

                <Text fontSize={"md"}>sec</Text>
              </Box>
            </Box>
          </Box>
        )}

        {!episeries && (
          <>
            <CreateInput
              name="Promotional Link"
              onChange={(e) => {
                podcastDataChage(e, "promotionalLink");
              }}
              value={
                newPodcast?.promotionalLink ? newPodcast.promotionalLink : ""
              }
            />
            {newPodcast?.trailerType === "Video" ? (
              <Box display="flex" flexDirection="column" gap={2} mb={2}>
                <Text fontSize="sm" color="gray.600">
                  Pick a trailer from Bunny (HLS URL is filled automatically), or
                  switch Trailer-Type to Youtube to paste a link.
                </Text>
                <Input
                  readOnly
                  placeholder="Select trailer from Bunny"
                  value={newPodcast?.trailer ? newPodcast.trailer : ""}
                />
                <Button colorScheme="blue" onClick={onBunnyTrailerOpen}>
                  Select trailer (Bunny)
                </Button>
                {update && newPodcast?.trailer && (
                  <Button
                    colorScheme="blue"
                    variant="outline"
                    onClick={() =>
                      handlePreview(
                        newPodcast.trailer,
                        "Trailer Preview",
                        newPodcast.trailerType
                      )
                    }
                  >
                    Preview
                  </Button>
                )}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  gap: "0.5rem",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <CreateInput
                  name={"Trailer (YouTube URL)"}
                  onChange={(e) => {
                    podcastDataChage(e, "trailer");
                  }}
                  value={newPodcast?.trailer ? newPodcast.trailer : ""}
                />
                {update && (
                  <Button
                    colorScheme="blue"
                    onClick={() =>
                      handlePreview(
                        newPodcast.trailer,
                        "Trailer Preview",
                        newPodcast.trailerType
                      )
                    }
                  >
                    Preview
                  </Button>
                )}
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                padding: "1rem 0rem",
                gap: ".5rem",
              }}
            >
              <FormLabel size={"sm"}>Genre</FormLabel>
              {genre?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    flexDirection: "column",
                    backgroundColor: "#eee",
                    padding: "1rem",
                    borderRadius: "0.5rem",
                  }}
                >
                  {genre.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text>{item.name ? item.name : item}</Text>
                      <Text
                        sx={{
                          color: "red.500",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const newGenre = genre.filter(
                            (item, i) => i !== index
                          );
                          setGenre(newGenre);
                        }}
                      >
                        Remove
                      </Text>
                    </Box>
                  ))}
                </Box>
              )}
              {/* <InputGroup size="md">
            <Input
              pr="4.5rem"
              placeholder="Add"
              value={newGenre}
              onChange={(e) => {
                setNewGenre(e.target.value);
              }}
            />
            <InputRightElement width="7rem">
              <Button
                size="sm"
                onClick={() => {
                  setGenre((prev) => [...prev, newGenre]);
                  setNewGenre("");
                }}
              >
                Create Genre
              </Button>
            </InputRightElement>
          </InputGroup> */}

              {allGenre?.length > 0 &&
                allGenre.map((item, index) => (
                  <CheckboxInput
                    name={item.name}
                    onChange={(e) => {
                      if (e.target.checked) {
                        const res = genre || [];

                        // setGenre((prev) => [...prev, item._id]);
                        res.push(item._id);
                        setGenre(res);
                      } else {
                        const newGenre = genre.filter(
                          (items) => items !== item._id
                        );
                        setGenre(newGenre);
                      }
                    }}
                  />
                ))}
            </Box>
            <CreateInput
              name="Rating"
              onChange={(e) => {
                setNewPodcast((prev) => {
                  return {
                    ...prev,
                    rating: e.target.value,
                  };
                });
              }}
              value={newPodcast?.rating ? newPodcast.rating : ""}
            />
            {update && !episeries && (
              <CreateInput
                name="Views"
                onChange={(e) => {
                  setNewPodcast((prev) => {
                    return {
                      ...prev,
                      view: e.target.value,
                    };
                  });
                }}
                value={newPodcast?.view ? newPodcast.view : ""}
              />
            )}
            <Text fontSize={"md"} fontWeight={"semibold"}>
              Language
            </Text>
            <Select
              placeholder="Select Language"
              value={newPodcast?.language ? newPodcast.language : ""}
              onChange={(e) => {
                setNewPodcast((prev) => {
                  return {
                    ...prev,
                    language: e.target.value,
                  };
                });
              }}
            >
              {allLanguages?.map((item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </Select>
            <CreateInput
              name="Age-Limit"
              onChange={(e) => {
                setNewPodcast((prev) => {
                  return {
                    ...prev,
                    ageLimit: e.target.value,
                  };
                });
              }}
              value={newPodcast?.ageLimit ? newPodcast.ageLimit : ""}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                padding: "1rem 0rem",
                gap: ".5rem",
              }}
            >
              <FormLabel size={"sm"}>Cast</FormLabel>
              {cast?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    flexDirection: "column",
                    backgroundColor: "#eee",
                    padding: "1rem",
                    borderRadius: "0.5rem",
                  }}
                >
                  {cast.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <Text>{item.name}</Text>
                      <Text
                        sx={{ color: "red.500", cursor: "pointer" }}
                        onClick={() => {
                          const newCast = cast.filter((item, i) => i !== index);
                          setCast(newCast);
                        }}
                      >
                        Remove
                      </Text>
                    </Box>
                  ))}
                </Box>
              )}
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  flexDirection: "column",
                  border: "1px solid #eee",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                }}
              >
                <Input
                  placeholder="Name"
                  onChange={(e) => {
                    setNewCast((prev) => ({ ...prev, name: e.target.value }));
                  }}
                  value={newCast?.name}
                />
                {/* Cast image file upload */}
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleCastImageUpload}
                  sx={{
                    border: "1px solid #e2e8f0",
                    borderRadius: "0.375rem",
                    padding: "0.5rem",
                  }}
                />
                {newCast?.image && (
                  <Text fontSize="sm" color="green.500" mt={1}>
                    ✓ Image Uploaded
                  </Text>
                )}
                <Input
                  placeholder="Role"
                  onChange={(e) => {
                    setNewCast((prev) => ({ ...prev, role: e.target.value }));
                  }}
                  value={newCast?.role}
                />
                <Button
                  size="sm"
                  onClick={() => {
                    const newCasts = cast || [];

                    newCasts.push(newCast);
                    setCast(newCasts);
                    setNewCast({
                      name: "",
                      image: "",
                      role: "",
                    });
                  }}
                >
                  Create Cast
                </Button>
              </Box>
              {!episeries && (
                <Input
                  placeholder="Supporting Actor/Actress"
                  onChange={(e) => {
                    setNewPodcast((prev) => {
                      return {
                        ...prev,
                        extraCast: e.target.value,
                      };
                    });
                  }}
                  value={newPodcast?.extraCast ? newPodcast.extraCast : ""}
                />
              )}
            </Box>
          </>
        )}
      </CreateModal>

      {/* Preview Modal */}
      <PreviewModal
        isOpen={isPreviewOpen}
        onClose={onPreviewClose}
        url={previewUrl}
        title={previewTitle}
        urlType={previewUrlType}
      />
      <BunnyVideoSelector
        isOpen={isBunnyMainOpen}
        onClose={onBunnyMainClose}
        onSelect={handleBunnyMainVideoSelect}
        title="Select main video (Bunny)"
      />
      <BunnyVideoSelector
        isOpen={isBunnyTrailerOpen}
        onClose={onBunnyTrailerClose}
        onSelect={handleBunnyTrailerSelect}
        title="Select trailer (Bunny)"
      />
    </Box>
  );
};

export default Modal;
